import TitleSection from "../../text/TitleSection/TitleSection";
import Section from "../Section";
import { AnimatedShorthandPattern } from "@/components/AnimatedShorthandPattern";
import { Button, Icon } from "@/components/Library";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeftArrowRight,
  faGrid2,
  faHandsHoldingDiamond,
  faLayerGroup,
  faPeopleGroup,
  faShieldCheck,
  faUpload,
  faWreathLaurel,
} from "@icons/duotone";
import { Link } from "gatsby";
import * as React from "react";

const allFeatures = [
  {
    id: 1,
    title: "Sections",
    icon: faGrid2,
    href: "/features/sections",
  },
  {
    id: 2,
    title: "Editor & layout",
    icon: faLayerGroup,
    href: "/features/editor-and-layout",
  },
  {
    id: 3,
    title: "Branding",
    icon: faWreathLaurel,
    href: "/features/branding",
  },
  {
    id: 4,
    title: "Collaborate",
    icon: faPeopleGroup,
    href: "/features/collaboration",
  },
  {
    id: 5,
    title: "Publish & host",
    icon: faUpload,
    href: "/features/publishing-and-hosting",
  },
  {
    id: 6,
    title: "Integrations",
    icon: faArrowLeftArrowRight,
    href: "/features/integrations",
  },
  {
    id: 7,
    title: "Support",
    icon: faHandsHoldingDiamond,
    href: "/features/support",
  },
  {
    id: 8,
    title: "Security",
    icon: faShieldCheck,
    href: "/features/security",
  },
];

export const CTA_TEXT = "Start creating";
export const CTA_LINK = "https://app.shorthand.com/signup";

export function LetsBuildFooter() {
  return (
    <Section>
      <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 md:tw-items-end">
        <div>
          <TitleSection
            headingElement="h2"
            subtitleVariant="cta"
            align="left"
            title={
              <>
                Let’s build something <span className="tw-font-PassengerSerif tw-italic">beautiful</span>.
              </>
            }
            description="Join thousands of storytellers using Shorthand to publish standout visual comms and content. Fast, flexible, and built for scale."
          />
          <div className="tw-mt-10 tw-flex tw-items-center tw-gap-x-6">
            <Button asChild variant="primary-gradient" size="lg">
              <a href={CTA_LINK} className="tw-no-underline hover:tw-no-underline">
                {CTA_TEXT}
              </a>
            </Button>
          </div>
        </div>
        <AnimatedShorthandPattern className="tw-hidden tw-size-1/4 md:tw-block lg:tw-size-1/5" />
      </div>
    </Section>
  );
}

export default function ProductFooter() {
  return (
    <>
      <Section>
        <div className="tw-rounded-lg tw-bg-grey_scale-800/50 tw-p-10 lg:tw-p-20">
          <TitleSection align="left" title="All features" description="Everything you need to tell your story, and more." />
          <div className="tw-mx-auto tw-mt-10 tw-grid tw-grid-cols-2 tw-items-center tw-gap-x-2 tw-gap-y-2 sm:tw-mt-16 sm:tw-gap-x-8 sm:tw-gap-y-8 md:tw-grid-cols-3 lg:tw-grid-cols-4 lg:tw-gap-x-8 lg:tw-gap-y-14">
            {allFeatures.map(feature => (
              <a
                href={feature.href}
                className="tw-group tw-flex tw-h-full tw-flex-col tw-gap-8 tw-rounded-lg tw-bg-grey_scale-800/50 tw-p-4 tw-no-underline hover:tw-no-underline hover:tw-ring-1 hover:tw-ring-white/20 md:tw-p-8"
                key={`editor-feature-${feature.id}`}
              >
                <Icon
                  icon={feature.icon as IconDefinition}
                  className="tw-size-6 tw-text-[var(--foreground-color)] sm:tw-size-7 lg:tw-size-8"
                />
                <span className="tw-max-w-[15ch] !tw-text-sm tw-text-white md:!tw-text-base">{feature.title}</span>
              </a>
            ))}
          </div>
        </div>
      </Section>

      <LetsBuildFooter />
    </>
  );
}
